.root {
  color: light-dark(var(--mantine-color-secondary-9), var(--mantine-color-primaryDark-2));
  font-weight: 400;

  &[aria-current] {
    font-weight: 700;
  }
}
